import { render } from "./PhraseListEditor.vue?vue&type=template&id=d6010bdc&scoped=true"
import script from "./PhraseListEditor.vue?vue&type=script&lang=js"
export * from "./PhraseListEditor.vue?vue&type=script&lang=js"

import "./PhraseListEditor.vue?vue&type=style&index=0&id=d6010bdc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6010bdc"]])

export default __exports__